module.exports = __webpack_public_path__ + "img/多边形2.26d95fdf.svg";